import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import React from 'react';
import { Card, CardText, Row, Col } from 'reactstrap';

export interface AdminSettingsCardProps {
  id?: string;
  icon: string;
  text: string | React.ReactNode;
  description: string;
  clickHandler?: React.MouseEventHandler<HTMLElement>;
  disabledText?: string;
  className?: string;
  isHidden?: boolean;
}

export const AdminSettingsCard = ({
  icon,
  text = '',
  description = '',
  clickHandler = () => {},
  disabledText = '',
  className = '',
}: AdminSettingsCardProps) => {
  return (
    <div className='settings-card-container h-100'>
      <SimpleTooltip text={disabledText}>
        <Card
          className={`settings-card h-100 ${className} ${disabledText ? 'disabled' : 'active'}`}
          body
          onClick={disabledText ? undefined : clickHandler}
        >
          <Row className='align-items-center h-100'>
            <Col className='col-3 text-center'>
              <i className={`fa-2x ${icon} ${disabledText ? 'text-ThemeBgDisabled' : 'text-ThemeIconSecondary'}`} />
            </Col>
            <Col className='col-9 ps-0'>
              <CardText
                tag={'h5'}
                className={`${disabledText ? 'text-ThemeBgDisabled' : 'text-ThemeHeadingDark'} mt-0`}
              >
                {text}
              </CardText>
              <CardText
                tag={'p'}
                className={`${disabledText ? 'text-ThemeBgDisabled' : 'text-ThemeHeadingLight'} text-xs`}
              >
                {description}
              </CardText>
            </Col>
          </Row>
        </Card>
      </SimpleTooltip>
    </div>
  );
};
